export const removeAlphabeticCharacteres = (value: string): string =>
  value.replace(/[^\d]/g, '')

export const stringNullOrEmpty = (value: string | null | undefined) =>
  !value || value.length === 0

const NAME_TITLES = /^(dra?\.?|sr\.?|sra\.?)\s+/i

export const getInitials = (name: string | null | undefined): string =>
  (name ?? '')
    .trim()
    .replace(NAME_TITLES, '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('')
